import { useWatch } from 'react-hook-form'
import { useInstallationForm } from './installation-form-hooks'
import { Device } from '../forms'

export const useInstallationFormDevices = (): Device[] => {
  const { control } = useInstallationForm()

  const [emc, storages, chargingStations, heatpump, meters, ioInterfaces] = useWatch({
    control,
    name: ['emcDevice', 'storageDevices', 'chargingStations', 'heatpump', 'meters', 'ioInterfaces'],
  })

  return [
    ...(emc ? [emc] : []),
    ...storages,
    ...chargingStations.eebus,
    ...chargingStations.modbusTcp,
    ...(heatpump ? [heatpump] : []),
    ...meters,
    ...(ioInterfaces.htc320h ? [ioInterfaces.htc320h] : []),
    ...(ioInterfaces.storage ? [ioInterfaces.storage] : []),
    ...(ioInterfaces.mypv ? [ioInterfaces.mypv] : []),
  ]
}
